import ApiClient from '@/api/ApiClient';

const client = new ApiClient('agency/requestedInformation');

class RequestedInformationApiAgency {
	static update (updateRequestedInformationModel: Omit<IUpdateRequestedInformationModel, 'agencyUserId'>) {
		return client.put<void>('', updateRequestedInformationModel);
	}

	static list (userId: number) {
		return client.get<IRequestedInformationForAgencyModel[]>(`list/${userId}`);
	}

	static add (addRequestedInformationModel: Omit<IAddRequestedInformationModel, 'agencyUserId'>) {
		return client.post<void>('', addRequestedInformationModel);
	}

	static addList (addRequestedInformationModel: Omit<IAddRequestedInformationMultipleModel, 'agencyUserId'>) {
		return client.post<void>('multiple', addRequestedInformationModel);
	}

	static addMultipleRequestedInformationsForOrder (addModel: IAddMultipleRequestedInformationsModel, orderId: number) {
		return client.post<void>(`multiple/order/${orderId}`, addModel);
	}
}

export default RequestedInformationApiAgency;
